import React from "react";
import PortfolioData from "./portfolioData";

function Item({ tag, handleModal }) {
  return (
    <div className="tab-container">
      {PortfolioData.filter((item) => item.tag.includes(tag)).map((item) => {
        const { id, delayAnimation, images, title } = item;
        return (
          <div key={id} data-aos="fade-right" data-aos-delay={delayAnimation}>
            <div
              className="tab-content shadow"
              onClick={() => handleModal(item)}
            >
              <img
                src={images?.[0]}
                style={{ objectFit: "cover" }}
                alt="portfolio project demo"
              />
              <h3>
                <span className="conent-title">{title}</span>
              </h3>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Item;
